module.exports = __webpack_public_path__ + "img/chrome.8db66a08.png";